(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-with-text"] && !Shopify.designMode) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	]

	const banner_with_text = () => {
		let headerOverlay = document.querySelector('.overlay')
		let pageAbout = document.querySelector('.page-about')
		let pageLookbook = document.querySelector('.page-lookbook')
		let breadCrumb = document.querySelector('.main-breadcrumb')
		let colorScheme = document.querySelector('.header-color-light')
		let colorSchemeDark = document.querySelector('.header-color-dark')
		let firstSection = document.querySelector('main section:first-of-type')

		if (
			headerOverlay &&
			firstSection.classList.contains('section-banner-with-text')
		) {
			document.querySelector('main').classList.add('page-about')
			let pageAbout = document.querySelector('.page-about')
			let pageLookbook = document.querySelector('.page-lookbook')
			if (colorScheme) {
				headerOverlay.classList.add('theme-dark')
				headerOverlay.classList.add('header-color-background-5')
				if (pageAbout || pageLookbook) {
					breadCrumb && breadCrumb.classList.add('color-background-5')
				}
			}

			if (colorSchemeDark) {
				headerOverlay.classList.remove('theme-dark')
				headerOverlay.classList.remove('header-color-background-5')
				headerOverlay.classList.add('color-background-1')
				if (pageAbout || pageLookbook) {
					breadCrumb && breadCrumb.classList.remove('color-background-5')
				}
			}
		} else {
			if (colorScheme) {
				if (pageAbout || pageLookbook) {
					breadCrumb && breadCrumb.classList.add('color-background-5')
				}
			}

			if (colorSchemeDark) {
				if (pageAbout || pageLookbook) {
					breadCrumb && breadCrumb.classList.remove('color-background-5')
				}
			}
		}
	}

	banner_with_text()

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			banner_with_text()
		})
	})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      //this.showActiveMedia();
      this.constProductPageSwiperCall();
    }
    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
          'data-media-id',
        )}"])`,
      ).forEach((element) => {
        element.classList.remove('active');
      });

      const activeMedia = this.querySelector(
        `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`,
      );
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate
        ? activeMediaTemplate.content
        : null;
      activeMedia.classList.add('active');

      activeMedia.scrollIntoView();

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }

    constProductPageSwiperCall(showActiveMedia) {
      const activeMedia = this.querySelector(
        `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`,
      );
      let activeMediaIndex = 0;

      this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
        if (element == activeMedia) {
          activeMediaIndex = index;
        }
      });

      const prodPageSwiper = new Swiper('#product-page-swiper', {
        zoom: true,
        centeredSlides: false,
        slidesPerView: 1,
        autoheight: true,
        watchSlidesVisibility: false,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        init: false,
        navigation: {
          nextEl: '.swiper-button-next-prod-page',
          prevEl: '.swiper-button-prev-prod-page',
        },
        pagination: {
          el: '.swiper-pagination-product-page',
          clickable: true,
        },
        on: {
          click: function (e) {
            if (this.zoom.scale === 1) {
              this.zoom.in();
            } else {
              this.zoom.out();
            }
          },
        },
      });

      prodPageSwiper.on('init', function () {
        prodPageSwiper.slideTo(activeMediaIndex, 0, false);
      });
      prodPageSwiper.init();

      document
        .querySelector('.product-media-modal__toggle')
        .addEventListener('click', function () {
          prodPageSwiper.destroy();
        });
    }
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector(
              'product-recommendations',
            );
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
		class StickyHeader extends HTMLElement {
		constructor() {
		super();
		}

		connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.header_overlay = document.querySelector('.header');
		this.headerOverlay = document.querySelector('.overlay');

		this.headerBounds = {};
		this.predictiveSearch = this.querySelector('predictive-search');
		this.currentScrollTop = 0;

		this.onScrollHandler = this.onScroll.bind(this);

		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
		}

		disconnectedCallback() {
		window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			observer.observe(this.header);
		}

		onScroll() {
			let logoSlideshowFirst = document.querySelector(".first-logo-slideshow")


			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (logoSlideshowFirst) {
				let logoSlideshowFirstHeight = logoSlideshowFirst.offsetHeight
				if (scrollTop > this.currentScrollTop && scrollTop > logoSlideshowFirstHeight && scrollTop > this.headerBounds.bottom) {
					requestAnimationFrame(this.hide.bind(this));
				if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
					this.predictiveSearch.onFocusOut();
					this.predictiveSearch.onBlur();
				}
				} else if (scrollTop - logoSlideshowFirstHeight < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
					requestAnimationFrame(this.reveal.bind(this));
				} else if (scrollTop - logoSlideshowFirstHeight <= this.headerBounds.top) {
					requestAnimationFrame(this.reset.bind(this));
				}

				this.currentScrollTop = scrollTop;
			} else {
				if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			requestAnimationFrame(this.hide.bind(this));
			if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
				this.predictiveSearch.onFocusOut();
				this.predictiveSearch.onBlur();
			}
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			requestAnimationFrame(this.reveal.bind(this));
			} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
			}
		}

		hide() {
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
			//this.closeSearchModal();
		}

		reveal() {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.headerOverlay && this.header_overlay.classList.add('header_overlay-scroll');
			this.header.classList.remove('shopify-section-header-hidden');
		}

		reset() {
			this.headerOverlay && this.header_overlay.classList.remove('header_overlay-scroll');
			this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		}

		closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		this.disclosures.forEach(disclosure => disclosure.close());
		}

		closeSearchModal() {
		this.searchModal = this.searchModal || this.header.querySelector('details-modal');
		this.searchModal.close(false);
		}
	}

	customElements.define('sticky-header', StickyHeader);

	const events = [
	"shopify:section:reorder",
	"shopify:section:deselect",
	"shopify:section:select",
	"shopify:section:unload",
	"shopify:section:load",
];

	const header_overlay = () => {
		let headerOverlay = document.querySelector(".overlay");
		let headerHeightOverlay = headerOverlay && headerOverlay.offsetHeight;

		document.documentElement.style.setProperty('--my-header-height', headerHeightOverlay + "px");

		if (headerOverlay) {
			document.querySelector("main").classList.add("header_overlay");
		}
		else{
			document.querySelector("main").classList.remove("header_overlay");
		}
	};

	header_overlay();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			header_overlay();
			});
	});

	const calculateHeaderHeight = () => {
		const headerHeight = document.querySelector('.header').offsetHeight;
		document.documentElement.style.setProperty('--header-dynamic-height', `${headerHeight}px`);
	}

	calculateHeaderHeight();

	let currHeaderSectionWidth = document.querySelector('.header').offsetWidth;

	const resizeObserver = new ResizeObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.contentRect.width !== currHeaderSectionWidth) {
				currHeaderSectionWidth = entry.contentRect.width;
				calculateHeaderHeight();
			}
		})
	})

	resizeObserver.observe(document.querySelector('.header'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const blog_header_overlay = () => {
		let headerOverlay = document.querySelector('.overlay');
		let colorScheme = document.querySelector('.header-color-light');

		if (headerOverlay) {
			if (colorScheme) {
				headerOverlay.classList.add('theme-dark');
				headerOverlay.classList.add('header-color-background-5');
			} else {
				headerOverlay.classList.remove('theme-dark');
				headerOverlay.classList.remove('header-color-background-5');
				headerOverlay.classList.add('color-background-1');
			}
		}
	};

	blog_header_overlay();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			blog_header_overlay();
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const main_collection_banner = () => {
		let headerOverlay = document.querySelector('.overlay');
		let colorScheme = document.querySelector('.header-color-light');

		if (headerOverlay) {
			if (colorScheme) {
				headerOverlay.classList.add('theme-dark');
				headerOverlay.classList.add('header-color-background-5');
			} else {
				headerOverlay.classList.remove('theme-dark');
				headerOverlay.classList.remove('header-color-background-5');
				headerOverlay.classList.add('color-background-1');
			}
		}
	};

	main_collection_banner();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			main_collection_banner();
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const account_header_overlay = () => {
		let headerOverlay = document.querySelector('.overlay');
		let colorScheme = document.querySelector('.header-color-light');

		if (headerOverlay) {
			if (colorScheme) {
				headerOverlay.classList.add('theme-dark');
				headerOverlay.classList.add('header-color-background-5');
			} else {
				headerOverlay.classList.remove('theme-dark');
				headerOverlay.classList.remove('header-color-background-5');
				headerOverlay.classList.add('color-background-1');
			}
		}
	};

	account_header_overlay();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			account_header_overlay();
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
		class ProductModal extends ModalDialog {
			constructor() {
				super();
			}

			hide() {
				super.hide();
				window.pauseAllMedia();
			}

			show(opener) {
				super.show(opener);
				//this.showActiveMedia();
				this.constProductPageSwiperCall()
			}
			showActiveMedia() {

				this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
						element.classList.remove('active');
					}
				)

				const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
				const activeMediaTemplate = activeMedia.querySelector('template');
				const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
				activeMedia.classList.add('active');

				activeMedia.scrollIntoView();

				if (
						activeMedia.nodeName == 'DEFERRED-MEDIA' &&
						activeMediaContent &&
						activeMediaContent.querySelector('.js-youtube')
					)
			activeMedia.loadContent();
			}

			constProductPageSwiperCall(showActiveMedia) {
				const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
				let activeMediaIndex = 0

				this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
						if(element == activeMedia){
							activeMediaIndex = index
						}
					}
				)

				const prodPageSwiper = new Swiper("#product-page-swiper", {
					zoom: true,
					centeredSlides: false,
					slidesPerView: 1,
					autoheight: true,
					watchSlidesVisibility: false,
					watchSlidesProgress: true,
					observer: true,
					observeParents: true,
					init: false,
					navigation: {
						nextEl: ".swiper-button-next-prod-page",
						prevEl: ".swiper-button-prev-prod-page",
					},
					pagination: {
						el: ".swiper-pagination-product-page",
						clickable: true,
					},
					on: {
						click: function (e) {
								if (this.zoom.scale === 1) {
								this.zoom.in();
								} else {
									this.zoom.out();
								}
       			 },
					},
				});

				prodPageSwiper.on('init', function() {
					prodPageSwiper.slideTo(activeMediaIndex, 0, false);
				});
				prodPageSwiper.init()

				document.querySelector('.product-media-modal__toggle').addEventListener("click", function(){ prodPageSwiper.destroy() });
			}
		}

		class ProductRecommendations extends HTMLElement {
			constructor() {
				super();

				const handleIntersection = (entries, observer) => {
					if (!entries[0].isIntersecting) return;
					observer.unobserve(this);

					fetch(this.dataset.url)
						.then(response => response.text())
						.then(text => {
							const html = document.createElement('div');
							html.innerHTML = text;
							const recommendations = html.querySelector('product-recommendations');
							if (recommendations && recommendations.innerHTML.trim().length) {
								this.innerHTML = recommendations.innerHTML;
							}
						})
						.catch(e => {
							console.error(e);
						});
				}

				new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
			}
		}

		customElements.define('product-modal', ProductModal);
		customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const account_header_overlay = () => {
		let headerOverlay = document.querySelector('.overlay');
		let colorScheme = document.querySelector('.header-color-light');

		if (headerOverlay) {
			if (colorScheme) {
				headerOverlay.classList.add('theme-dark');
				headerOverlay.classList.add('header-color-background-5');
			} else {
				headerOverlay.classList.remove('theme-dark');
				headerOverlay.classList.remove('header-color-background-5');
				headerOverlay.classList.add('color-background-1');
			}
		}
	};

	account_header_overlay();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			account_header_overlay();
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations-also-like'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define(
		'product-recommendations-also-like',
		ProductRecommendations
	);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slideshow"] && !Shopify.designMode) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	]

	const banner_with_text = () => {
		let headerOverlay = document.querySelector('.overlay')
		let colorScheme = document.querySelector('.header-color-theme-light')
		let colorSchemeDark = document.querySelector('.header-color-theme-dark')
		let firstSection = document.querySelector('main section:first-of-type')

		if (
			headerOverlay &&
			firstSection.classList.contains('product-slideshow-section')
		) {
			document.querySelector('main').classList.add('page-about')
			if (colorSchemeDark) {
				headerOverlay.classList.add('theme-dark')
				headerOverlay.classList.add('header-color-background-5')
			}

			if (colorScheme) {
				headerOverlay.classList.remove('theme-dark')
				headerOverlay.classList.remove('header-color-background-5')
				headerOverlay.classList.add('color-background-1')
			}
		}
	}

	banner_with_text()

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			banner_with_text()
		})
	})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	]

	const slideshow_section = () => {
		let headerOverlay = document.querySelector('.overlay')
		let page = document.querySelector('.template-page')
		let breadCrumb = document.querySelector('.main-breadcrumb')
		let firstSection = document.querySelector('main section:first-of-type')

		if (
			page &&
			headerOverlay &&
			firstSection.classList.contains('slideshow-section') &&
			breadCrumb
		) {
			breadCrumb.classList.add('template-page-breadcrumb')
			if (headerOverlay.classList.contains('theme-dark')) {
				breadCrumb.classList.add('color-background-5')
			}
		}
	}

	slideshow_section()

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			slideshow_section()
		})
	})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solene-about"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('solene-about-story')){class SoleneAboutStory extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.slides=[...this.querySelectorAll('[data-sa-slide]')];this.tabs=[...this.querySelectorAll('[data-sa-tab]')];this.status=this.querySelector('[data-sa-status]');this.index=0;this.clickHandler=event=>{const tab=event.target.closest('[data-sa-tab]');if(tab)this.show(Number(tab.dataset.saTab),true);if(event.target.closest('[data-sa-previous]'))this.show(this.index-1,true);if(event.target.closest('[data-sa-next]'))this.show(this.index+1,true)};this.keyHandler=event=>{if(event.key==='ArrowLeft'){event.preventDefault();this.show(this.index-1,true)}if(event.key==='ArrowRight'){event.preventDefault();this.show(this.index+1,true)}};this.pointerStart=event=>{this.startX=event.clientX};this.pointerEnd=event=>{if(this.startX===undefined)return;const distance=event.clientX-this.startX;this.startX=undefined;if(Math.abs(distance)>45)this.show(this.index+(distance<0?1:-1),false)};this.editorHandler=event=>{if(!this.contains(event.target))return;const slide=this.slides.find(item=>item.dataset.saBlockId===event.detail.blockId);if(slide)this.show(this.slides.indexOf(slide),false)};this.addEventListener('click',this.clickHandler);this.addEventListener('keydown',this.keyHandler);this.querySelector('[data-sa-slider]')?.addEventListener('pointerdown',this.pointerStart);this.querySelector('[data-sa-slider]')?.addEventListener('pointerup',this.pointerEnd);document.addEventListener('shopify:block:select',this.editorHandler);const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;this.querySelectorAll('.sa-hero [data-sa-reveal]').forEach(element=>{if(reduced){element.classList.add('is-visible');return}this.observer??=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');this.observer.unobserve(entry.target)}}),{threshold:.12,rootMargin:'0px 0px -8%'});this.observer.observe(element)});this.show(0,false)}show(next,focus){if(!this.slides.length)return;this.index=(next+this.slides.length)%this.slides.length;this.slides.forEach((slide,index)=>{const active=index===this.index;slide.hidden=!active;slide.classList.toggle('is-active',active);slide.classList.toggle('is-visible',active)});this.tabs.forEach((tab,index)=>{const active=index===this.index;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1});if(this.status)this.status.textContent=(this.index+1)+' / '+this.slides.length;if(focus)this.tabs[this.index]?.focus({preventScroll:true})}disconnectedCallback(){this.observer?.disconnect();this.removeEventListener('click',this.clickHandler);this.removeEventListener('keydown',this.keyHandler);this.querySelector('[data-sa-slider]')?.removeEventListener('pointerdown',this.pointerStart);this.querySelector('[data-sa-slider]')?.removeEventListener('pointerup',this.pointerEnd);document.removeEventListener('shopify:block:select',this.editorHandler);this.ready=false}}customElements.define('solene-about-story',SoleneAboutStory)}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solene-ear-studio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('solene-ear-studio')) {
  class SoleneEarStudio extends HTMLElement {
    connectedCallback() {
      if(this.controller)return;
      this.controller=new AbortController();this.items=[];this.active=null;this.cache=new Map();this.generation=0;this.pending=0;this.serial=0;
      this.scene=this.querySelector('[data-scene]');this.layerHost=this.querySelector('[data-layers]');this.status=this.querySelector('[data-status]');
      this.points=[...this.querySelectorAll('[data-point]')];this.point=this.points[0];
      this.on(this,'click',e=>this.click(e));this.on(this,'input',e=>this.input(e));this.on(this,'pointerdown',e=>this.down(e));
      this.on(document,'pointermove',e=>this.move(e));this.on(document,'pointerup',e=>this.up(e));this.on(document,'pointercancel',()=>this.cancelDrag());
      this.on(this,'keydown',e=>this.key(e));this.on(document,'keydown',e=>{if(e.key==='Escape')this.cancelDrag();});
      this.on(document,'shopify:block:select',e=>{if(!this.contains(e.target))return;const p=this.points.find(p=>p.dataset.point===e.detail.blockId);if(p)this.choosePoint(p);const b=this.querySelector('[data-piece][data-block-id="'+e.detail.blockId+'"]');if(b){b.scrollIntoView({block:'nearest'});this.add(b);}});
      this.querySelector('[data-empty]').hidden=!!this.querySelector('[data-piece]');this.togglePoints();this.on(this.querySelector('.ses-ear'),'load',()=>this.items.forEach(item=>this.renderItem(item)));
    }
    disconnectedCallback(){this.cancelDrag();this.generation++;this.controller?.abort();this.controller=null;this.layerHost?.replaceChildren();this.cache?.clear();}
    on(node,event,fn){node.addEventListener(event,fn,{signal:this.controller.signal});}
    say(key){this.status.textContent=this.dataset[key]||'';}
    clamp(n,min,max){return Math.max(min,Math.min(max,n));}
    selected(){return this.items.find(x=>x.id===this.active);}
    click(e){
      if(this.suppressClick){e.preventDefault();return;}
      const piece=e.target.closest('[data-piece]');if(piece){this.add(piece);return;}
      const p=e.target.closest('[data-position],[data-point]');if(p){this.choosePoint(this.points.find(x=>x.dataset.point===(p.dataset.position||p.dataset.point)));return;}
      const layer=e.target.closest('[data-layer],[data-select]');if(layer){this.select(Number(layer.dataset.layer||layer.dataset.select));return;}
      const action=e.target.closest('[data-action]')?.dataset.action;const item=this.selected();
      if(action==='reset'){this.generation++;this.pending=0;this.items=[];this.active=null;this.layerHost.replaceChildren();this.renderControls();this.say('reset');return;}
      if(action&&item){if(action==='remove'){item.el.remove();this.items=this.items.filter(x=>x!==item);this.active=this.items.at(-1)?.id||null;this.say('removed');}if(action==='flip')item.flip*=-1;if(action==='fit'){item.height=Number(item.piece.dataset.height);item.rotation=Number(item.piece.dataset.rotation);item.flip=1;}this.renderItem(item);this.renderControls();}
      const n=e.target.closest('[data-nudge]')?.dataset.nudge;if(n&&item){this.nudge(item,n,.25);}
    }
    input(e){const item=this.selected();if(e.target.matches('[data-show-points]'))this.togglePoints();if(!item)return;if(e.target.matches('[data-scale]'))item.height=Number(e.target.value);if(e.target.matches('[data-angle-control]'))item.rotation=Number(e.target.value);this.renderItem(item);this.updateRanges(item);}
    togglePoints(){this.querySelector('[data-points-layer]').hidden=!this.querySelector('[data-show-points]').checked;}
    choosePoint(point){if(!point)return;this.point=point;this.querySelectorAll('[data-position],[data-point]').forEach(p=>p.setAttribute('aria-pressed',String((p.dataset.position||p.dataset.point)===point.dataset.point)));const item=this.selected();if(item){item.x=Number(point.dataset.x);item.y=Number(point.dataset.y);this.renderItem(item);}}
    position(clientX,clientY,snap=true){const r=this.scene.getBoundingClientRect();let x=this.clamp((clientX-r.left)/r.width*100,0,100),y=this.clamp((clientY-r.top)/r.height*100,0,100);if(snap&&this.querySelector('[data-snap]').checked){let best=null,distance=24;this.points.forEach(p=>{const d=Math.hypot((x-p.dataset.x)*r.width/100,(y-p.dataset.y)*r.height/100);if(d<distance){best=p;distance=d;}});if(best){x=Number(best.dataset.x);y=Number(best.dataset.y);}}return{x,y};}
    async add(piece,position){
      if(this.items.length+this.pending>=Number(this.dataset.max)){this.say('limit');return;}
      const generation=this.generation;this.pending++;this.say('loading');
      try{const art=await this.artwork(piece);if(generation!==this.generation||!this.isConnected)return;
        const item={id:++this.serial,piece,art,x:position?.x??Number(this.point?.dataset.x||45),y:position?.y??Number(this.point?.dataset.y||45),height:Number(piece.dataset.height),rotation:Number(piece.dataset.rotation),anchorX:Number(piece.dataset.anchorX),anchorY:Number(piece.dataset.anchorY),flip:1};
        const el=document.createElement('button');el.type='button';el.className='ses-layer';el.dataset.layer=item.id;el.setAttribute('aria-label',this.dataset.moveLabel+' '+piece.dataset.title);const img=document.createElement('img');img.src=art.url;img.alt='';img.draggable=false;el.append(img);item.el=el;this.layerHost.append(el);this.items.push(item);this.renderItem(item);this.select(item.id);this.say('added');
      }catch(error){if(generation===this.generation)this.say('error');}finally{if(generation===this.generation)this.pending=Math.max(0,this.pending-1);}
    }
    artwork(piece){const key=[piece.dataset.source,piece.dataset.crop,piece.dataset.cleanup,piece.dataset.cropX,piece.dataset.cropY,piece.dataset.cropWidth,piece.dataset.cropHeight].join('|');if(!this.cache.has(key)){const promise=this.prepare(piece).catch(e=>{this.cache.delete(key);throw e;});this.cache.set(key,promise);}return this.cache.get(key);}
    async prepare(piece){
      const img=new Image();img.crossOrigin='anonymous';await new Promise((resolve,reject)=>{const timer=setTimeout(()=>reject(new Error('Image timeout')),15000);img.onload=()=>{clearTimeout(timer);resolve();};img.onerror=()=>{clearTimeout(timer);reject(new Error('Image unavailable'));};img.src=piece.dataset.source;});
      const side=piece.dataset.crop;let sx=0,sy=0,sw=img.naturalWidth,sh=img.naturalHeight;
      if(side==='custom'){sx=img.naturalWidth*Number(piece.dataset.cropX||0)/100;sy=img.naturalHeight*Number(piece.dataset.cropY||0)/100;sw=Math.min(img.naturalWidth-sx,img.naturalWidth*Number(piece.dataset.cropWidth||50)/100);sh=Math.min(img.naturalHeight-sy,img.naturalHeight*Number(piece.dataset.cropHeight||100)/100);}
      else if(side!=='full'){sw=Math.floor(sw/2);if(side==='right')sx=sw;}
      const ratio=Math.min(1,700/Math.max(sw,sh)),w=Math.max(1,Math.round(sw*ratio)),h=Math.max(1,Math.round(sh*ratio));
      const canvas=document.createElement('canvas');canvas.width=w;canvas.height=h;const ctx=canvas.getContext('2d',{willReadFrequently:true});ctx.drawImage(img,sx,sy,sw,sh,0,0,w,h);const pixels=ctx.getImageData(0,0,w,h),d=pixels.data;
      if(piece.dataset.cleanup==='true'){
        const seen=new Uint8Array(w*h),queue=new Int32Array(w*h);let head=0,tail=0;
        const visit=i=>{if(seen[i])return;seen[i]=1;const p=i*4,lo=Math.min(d[p],d[p+1],d[p+2]),hi=Math.max(d[p],d[p+1],d[p+2]);if(d[p+3]<16||(lo>249&&hi-lo<8)){queue[tail++]=i;d[p+3]=0;}};
        for(let x=0;x<w;x++){visit(x);visit((h-1)*w+x);}for(let y=0;y<h;y++){visit(y*w);visit(y*w+w-1);}
        while(head<tail){const i=queue[head++],x=i%w;if(x>0)visit(i-1);if(x<w-1)visit(i+1);if(i>=w)visit(i-w);if(i<w*(h-1))visit(i+w);}
      }
      if(piece.dataset.cleanup==='true'){
        const visited=new Uint8Array(w*h),queue=new Int32Array(w*h);
        for(let start=0;start<w*h;start++){
          if(visited[start])continue;const p=start*4;if(d[p+3]<31||Math.min(d[p],d[p+1],d[p+2])<247)continue;
          let head=0,tail=1;queue[0]=start;visited[start]=1;
          while(head<tail){const i=queue[head++],x=i%w;for(const next of [x>0?i-1:-1,x<w-1?i+1:-1,i>=w?i-w:-1,i<w*(h-1)?i+w:-1]){if(next<0||visited[next])continue;const q=next*4;if(d[q+3]>30&&Math.min(d[q],d[q+1],d[q+2])>=247){visited[next]=1;queue[tail++]=next;}}}
          if(tail>w*h*.025)for(let j=0;j<tail;j++)d[queue[j]*4+3]=0;
        }
      }
      if(side!=='full'){
        const labels=new Int32Array(w*h),queue=new Int32Array(w*h);let label=0,best=0,bestSize=0;
        for(let start=0;start<w*h;start++){if(labels[start]||d[start*4+3]<31)continue;label++;let head=0,tail=1;queue[0]=start;labels[start]=label;
          while(head<tail){const i=queue[head++],x=i%w;for(const next of [x>0?i-1:-1,x<w-1?i+1:-1,i>=w?i-w:-1,i<w*(h-1)?i+w:-1]){if(next>=0&&!labels[next]&&d[next*4+3]>30){labels[next]=label;queue[tail++]=next;}}}
          if(tail>bestSize){bestSize=tail;best=label;}
        }
        for(let i=0;i<w*h;i++)if(labels[i]!==best)d[i*4+3]=0;
      }
      let minX=w,minY=h,maxX=-1,maxY=-1;for(let y=0;y<h;y++)for(let x=0;x<w;x++)if(d[(y*w+x)*4+3]>30){minX=Math.min(minX,x);maxX=Math.max(maxX,x);minY=Math.min(minY,y);maxY=Math.max(maxY,y);}
      if(maxX<0)throw new Error('No earring visible');ctx.putImageData(pixels,0,0);const trim=document.createElement('canvas');trim.width=maxX-minX+1;trim.height=maxY-minY+1;trim.getContext('2d').drawImage(canvas,minX,minY,trim.width,trim.height,0,0,trim.width,trim.height);return{url:trim.toDataURL('image/png'),ratio:trim.width/trim.height};
    }
    renderItem(item){if(!item?.el?.isConnected)return;const anchorX=item.flip===1?item.anchorX:100-item.anchorX;item.el.style.left=item.x+'%';item.el.style.top=item.y+'%';item.el.style.height=item.height+'%';item.el.style.width=(item.height*item.art.ratio*1.5)+'%';item.el.style.aspectRatio=String(item.art.ratio);const ear=this.querySelector('.ses-ear');const ratio=ear?.naturalWidth&&ear?.naturalHeight?ear.naturalHeight/ear.naturalWidth:1.5;item.el.style.width=(item.height*item.art.ratio*ratio)+'%';item.el.style.transformOrigin=anchorX+'% '+item.anchorY+'%';item.el.style.transform='translate(-'+anchorX+'%,-'+item.anchorY+'%) rotate('+item.rotation+'deg)';item.el.firstChild.style.transform='scaleX('+item.flip+')';}
    select(id){this.active=id;this.items.forEach(x=>{x.el.setAttribute('aria-pressed',String(x.id===id));x.el.style.zIndex=x.id===id?3:1;});this.renderControls();}
    renderControls(){const item=this.selected();this.querySelector('[data-adjust]').hidden=!item;this.querySelectorAll('[data-piece]').forEach(p=>p.setAttribute('aria-pressed',String(this.items.some(x=>x.piece===p))));const look=this.querySelector('[data-look]');look.replaceChildren();this.items.forEach(x=>{const b=document.createElement('button');b.type='button';b.dataset.select=x.id;b.setAttribute('aria-label',x.piece.dataset.title);b.setAttribute('aria-pressed',String(x.id===this.active));const img=document.createElement('img');img.src=x.art.url;img.alt='';b.append(img);look.append(b);});if(!item)return;this.querySelector('[data-current-title]').textContent=item.piece.dataset.title;this.querySelector('[data-current-price]').textContent=item.piece.dataset.price;this.querySelector('[data-shop]').href=item.piece.dataset.url;this.updateRanges(item);}
    updateRanges(item){this.querySelector('[data-scale]').value=item.height;this.querySelector('[data-angle-control]').value=item.rotation;this.querySelector('[data-scale-output]').textContent=item.height+'%';this.querySelector('[data-rotation-output]').textContent=item.rotation+'°';}
    down(e){if(e.button!==0)return;const layer=e.target.closest('[data-layer]'),piece=e.target.closest('[data-piece]');if(!layer&&!piece)return;
      if(layer){this.select(Number(layer.dataset.layer));const item=this.selected();this.drag={pointer:e.pointerId,item,startX:e.clientX,startY:e.clientY,oldX:item.x,oldY:item.y,ready:true};layer.setPointerCapture(e.pointerId);layer.classList.add('is-dragging');e.preventDefault();}
      else{const handle=e.target.closest('[data-drag-handle]');this.drag={pointer:e.pointerId,piece,startX:e.clientX,startY:e.clientY,ready:e.pointerType==='mouse'||!!handle};if(handle){piece.setPointerCapture(e.pointerId);e.preventDefault();}}
    }
    makeGhost(x,y){if(!this.drag||this.drag.ghost)return;const ghost=document.createElement('img');ghost.className='ses-drag-ghost';ghost.src=this.drag.piece.dataset.source;ghost.alt='';ghost.style.left=x+'px';ghost.style.top=y+'px';document.body.append(ghost);this.drag.ghost=ghost;}
    move(e){const d=this.drag;if(!d||d.pointer!==e.pointerId)return;const distance=Math.hypot(e.clientX-d.startX,e.clientY-d.startY);if(!d.ready){if(distance>8)this.cancelDrag();return;}if(distance<5&&!d.moved)return;d.moved=true;
      if(d.item){const r=this.scene.getBoundingClientRect();d.item.x=this.clamp(d.oldX+(e.clientX-d.startX)/r.width*100,0,100);d.item.y=this.clamp(d.oldY+(e.clientY-d.startY)/r.height*100,0,100);this.renderItem(d.item);}
      else{this.makeGhost(e.clientX,e.clientY);d.ghost.style.left=e.clientX+'px';d.ghost.style.top=e.clientY+'px';const r=this.scene.getBoundingClientRect();this.scene.classList.toggle('is-drop-target',e.clientX>=r.left&&e.clientX<=r.right&&e.clientY>=r.top&&e.clientY<=r.bottom);}
    }
    up(e){const d=this.drag;if(!d||d.pointer!==e.pointerId)return;if(d.moved){this.suppressClick=true;setTimeout(()=>this.suppressClick=false,0);if(d.item){const r=this.scene.getBoundingClientRect(),p=this.position(r.left+d.item.x*r.width/100,r.top+d.item.y*r.height/100);Object.assign(d.item,p);this.renderItem(d.item);}else{const r=this.scene.getBoundingClientRect();if(e.clientX>=r.left&&e.clientX<=r.right&&e.clientY>=r.top&&e.clientY<=r.bottom)this.add(d.piece,this.position(e.clientX,e.clientY));}}this.cancelDrag(false);}
    cancelDrag(restore=true){const d=this.drag;if(!d)return;clearTimeout(d.timer);d.ghost?.remove();if(d.item){d.item.el.classList.remove('is-dragging');if(restore){d.item.x=d.oldX;d.item.y=d.oldY;this.renderItem(d.item);}}this.scene?.classList.remove('is-drop-target');this.drag=null;}
    nudge(item,direction,amount){const moves={left:[-1,0],right:[1,0],up:[0,-1],down:[0,1]},m=moves[direction];item.x=this.clamp(item.x+m[0]*amount,0,100);item.y=this.clamp(item.y+m[1]*amount,0,100);this.renderItem(item);}
    key(e){if(!e.target.matches('[data-layer]'))return;const item=this.items.find(x=>x.id===Number(e.target.dataset.layer));const dir={ArrowLeft:'left',ArrowRight:'right',ArrowUp:'up',ArrowDown:'down'}[e.key];if(dir){e.preventDefault();this.nudge(item,dir,e.shiftKey?1:.25);}if(e.key==='Delete'||e.key==='Backspace'){e.preventDefault();this.querySelector('[data-action="remove"]').click();}}
  }
  customElements.define('solene-ear-studio',SoleneEarStudio);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solene-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('solene-experience')) customElements.define('solene-experience', class extends HTMLElement {
connectedCallback() {
 if(this.abort) return;
 this.abort=new AbortController();const signal=this.abort.signal;
 const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
 const hero=this.querySelector('[data-solene-slider]');
 if(hero){const slides=[...hero.querySelectorAll('[data-solene-slide]')];const dots=[...hero.querySelectorAll('[data-solene-dot]')];const links=slides.map(slide=>slide.querySelector('.solene-hero-slide-link'));let active=0;let timer;const go=index=>{active=(index+slides.length)%slides.length;slides.forEach((slide,i)=>{const selected=i===active;slide.classList.toggle('is-active',selected);slide.setAttribute('aria-hidden',String(!selected));if(links[i])links[i].tabIndex=selected?0:-1;});dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===active)));};const stop=()=>{if(timer)clearInterval(timer);timer=null;};const play=()=>{stop();if(!reduced()&&slides.length>1)timer=setInterval(()=>go(active+1),6200);};hero.querySelector('[data-solene-hero-prev]')?.addEventListener('click',()=>{go(active-1);play();},{signal});hero.querySelector('[data-solene-hero-next]')?.addEventListener('click',()=>{go(active+1);play();},{signal});dots.forEach(dot=>dot.addEventListener('click',()=>{go(Number(dot.dataset.slide)||0);play();},{signal}));hero.addEventListener('mouseenter',stop,{signal});hero.addEventListener('mouseleave',play,{signal});hero.addEventListener('focusin',stop,{signal});hero.addEventListener('focusout',play,{signal});signal.addEventListener('abort',stop,{once:true});go(0);play();}
 const toggle=this.querySelector('.solene-motion-toggle');
 if(toggle)toggle.addEventListener('click',()=>{const paused=toggle.getAttribute('aria-pressed')!=='true';toggle.setAttribute('aria-pressed',String(paused));this.querySelector('.solene-ribbon-track').style.animationPlayState=paused?'paused':'running';toggle.textContent=paused?toggle.dataset.resume:toggle.dataset.pause;},{signal});
 const tryOn=this.querySelector('[data-solene-try-on]');
 if(tryOn){const preview=tryOn.querySelector('[data-solene-try-link]');const image=tryOn.querySelector('[data-solene-try-image]');const title=tryOn.querySelector('[data-solene-try-title]');const price=tryOn.querySelector('[data-solene-try-price]');const pieces=[...tryOn.querySelectorAll('[data-solene-try-piece]')];const positions=[...tryOn.querySelectorAll('[data-solene-try-position]')];const overlay=tryOn.querySelector('.solene-try-on__earring-link');let selectedImage='';let dx=0;let dy=0;let scale=1;const applyTransparent=img=>{if(!img||img.tagName!=='IMG'||!img.complete)return;try{const source=document.createElement('canvas');const w=img.naturalWidth;const h=img.naturalHeight;if(!w||!h)return;source.width=w;source.height=h;const ctx=source.getContext('2d',{willReadFrequently:true});ctx.drawImage(img,0,0);const data=ctx.getImageData(0,0,w,h);const px=data.data;let minX=w,minY=h,maxX=0,maxY=0;for(let i=0;i<px.length;i+=4){const r=px[i],g=px[i+1],b=px[i+2];const bright=(r+g+b)/3;const neutral=Math.max(r,g,b)-Math.min(r,g,b);let alpha=px[i+3];if(bright>238&&neutral<18){alpha=0;px[i+3]=0;}else if(bright>225&&neutral<24){alpha=Math.min(alpha,95);px[i+3]=alpha;}if(alpha>24&&bright<248){const p=i/4;const x=p%w;const y=Math.floor(p/w);if(x<minX)minX=x;if(y<minY)minY=y;if(x>maxX)maxX=x;if(y>maxY)maxY=y;}}if(maxX<=minX||maxY<=minY)return;ctx.putImageData(data,0,0);const boxW=maxX-minX+1;const boxH=maxY-minY+1;let cropX=minX;let cropW=boxW;if(boxW>boxH*.78){const mid=minX+boxW/2;let leftCount=0;let rightCount=0;for(let y=minY;y<=maxY;y+=2){for(let x=minX;x<=maxX;x+=2){const a=px[(y*w+x)*4+3];if(a>24){if(x<mid)leftCount++;else rightCount++;}}}cropW=Math.ceil(boxW*.52);cropX=rightCount>leftCount?Math.floor(maxX-cropW+1):minX;}const pad=Math.max(10,Math.round(Math.max(cropW,boxH)*.16));const out=document.createElement('canvas');out.width=cropW+pad*2;out.height=boxH+pad*2;const outCtx=out.getContext('2d');outCtx.clearRect(0,0,out.width,out.height);outCtx.drawImage(source,cropX,minY,cropW,boxH,pad,pad,cropW,boxH);img.src=out.toDataURL('image/png');img.dataset.transparentized='true';}catch(error){img.style.mixBlendMode='multiply';}};const applyFit=()=>{if(overlay){overlay.style.setProperty('--solene-try-x-adjust',dx+'px');overlay.style.setProperty('--solene-try-y-adjust',dy+'px');overlay.style.setProperty('--solene-try-scale',scale.toFixed(2));}};const setPosition=button=>{positions.forEach(position=>{const active=position===button;position.classList.toggle('is-active',active);position.setAttribute('aria-pressed',String(active));});if(overlay){overlay.style.setProperty('--solene-active-x',(button.dataset.x||58)+'%');overlay.style.setProperty('--solene-active-y',(button.dataset.y||52)+'%');overlay.style.setProperty('--solene-active-size',(button.dataset.size||30)+'%');overlay.style.setProperty('--solene-active-mobile-x',(button.dataset.x||58)+'%');overlay.style.setProperty('--solene-active-mobile-y',(button.dataset.y||52)+'%');overlay.style.setProperty('--solene-active-mobile-size',String(Math.min(22,Number(button.dataset.size||14)+2))+'%');}};const choose=button=>{pieces.forEach(piece=>{const active=piece===button;piece.classList.toggle('is-active',active);piece.setAttribute('aria-pressed',String(active));});if(preview&&button.dataset.url)preview.href=button.dataset.url;if(title)title.textContent=button.dataset.title||'';if(price)price.textContent=button.dataset.price||'';if(image&&image.tagName==='IMG'&&button.dataset.image){selectedImage=button.dataset.image;image.dataset.transparentized='false';image.crossOrigin='anonymous';image.style.opacity='.18';setTimeout(()=>{image.src=selectedImage;image.alt=button.dataset.title||'';},100);}};pieces.forEach(button=>button.addEventListener('click',()=>choose(button),{signal}));positions.forEach(button=>button.addEventListener('click',()=>setPosition(button),{signal}));if(image&&image.tagName==='IMG'){image.crossOrigin='anonymous';image.addEventListener('load',()=>{image.style.opacity='1';if(image.dataset.transparentized!=='true')applyTransparent(image);},{signal});if(image.complete)applyTransparent(image);}positions[0]&&setPosition(positions[0]);applyFit();}
 const panels=[...this.querySelectorAll('.solene-spotlight-panel')];const selectors=this.querySelector('.solene-spotlight-selectors');
 if(selectors&&panels.length){selectors.hidden=false;const buttons=[...selectors.querySelectorAll('button')];const select=index=>{panels.forEach((p,i)=>p.hidden=i!==index);buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));if(!reduced())panels[index].animate([{opacity:.25,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:500,easing:'ease-out'});};buttons.forEach((button,index)=>button.addEventListener('click',()=>select(index),{signal}));panels.forEach((p,i)=>p.hidden=i!==0);}
 const rail=this.querySelector('.solene-grid');
 if(rail){const buttons=this.querySelectorAll('[data-direction]');const update=()=>buttons.forEach(b=>b.disabled=Number(b.dataset.direction)<0?rail.scrollLeft<=2:rail.scrollLeft>=rail.scrollWidth-rail.clientWidth-2);
 buttons.forEach(b=>b.addEventListener('click',()=>{const card=rail.querySelector('.solene-card');rail.scrollBy({left:((card?card.getBoundingClientRect().width:rail.clientWidth)+(parseFloat(getComputedStyle(rail).columnGap)||0))*Number(b.dataset.direction),behavior:reduced()?'instant':'smooth'});},{signal}));rail.addEventListener('scroll',update,{passive:true,signal});this.observer=new ResizeObserver(update);this.observer.observe(rail);update();}
 const revealTargets=[...this.querySelectorAll('.solene-hero-slider,.solene-section-heading,.solene-try-on__copy,.solene-try-on__stage,.solene-try-on__product,.solene-product-edit__copy,.solene-product-edit__visual,.solene-product-edit-card,.solene-moment,.solene-card,.solene-spotlight-intro,.solene-spotlight-panel,.solene-story-image,.solene-story-copy,.solene-accordions details,.solene-finale')];
 revealTargets.forEach(el=>el.setAttribute('data-solene-scroll',''));
 if(reduced()){revealTargets.forEach(el=>el.classList.add('is-visible'));return;}
 if('IntersectionObserver' in window){this.reveal=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');this.reveal.unobserve(entry.target);}});},{threshold:.12,rootMargin:'0px 0px -10% 0px'});revealTargets.forEach((el,index)=>{el.style.transitionDelay=Math.min(index%4*75,225)+'ms';this.reveal.observe(el);});}else{revealTargets.forEach(el=>el.classList.add('is-visible'));}
 const depthTargets=[...this.querySelectorAll('.solene-try-on__stage,.solene-product-edit__visual,.solene-story-image,.solene-moment')];const driftTargets=[];
 const depth=()=>{const h=innerHeight||1;depthTargets.forEach(el=>{const r=el.getBoundingClientRect();const p=(r.top+r.height/2-h/2)/h;el.style.setProperty('--solene-depth',Math.max(-18,Math.min(18,p*26)).toFixed(2)+'px');});};
 depth();addEventListener('scroll',depth,{passive:true,signal});addEventListener('resize',depth,{signal});
}
disconnectedCallback(){this.observer?.disconnect();this.reveal?.disconnect();this.abort?.abort();this.abort=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const banner_video = () => {
		let headerOverlay = document.querySelector('.overlay');
		let pageAbout = document.querySelector('.page-about');
		let pageLookbook = document.querySelector('.page-lookbook');
		let breadCrumb = document.querySelector('.main-breadcrumb');
		let colorScheme = document.querySelector('.header-color-light');
		let colorSchemeDark = document.querySelector('.header-color-dark');
		let firstSection = document.querySelector('section:first-of-type');

		if (
			headerOverlay &&
			firstSection.classList.contains('video-banner-section')
		) {
			document.querySelector('main').classList.add('page-about');
			let pageAbout = document.querySelector('.page-about');
			let pageLookbook = document.querySelector('.page-lookbook');
			if (colorScheme) {
				headerOverlay.classList.add('theme-dark');
				headerOverlay.classList.add('header-color-background-5');
				if (pageAbout || pageLookbook) {
					breadCrumb.classList.add('color-background-5');
				}
			}

			if (colorSchemeDark) {
				headerOverlay.classList.remove('theme-dark');
				headerOverlay.classList.remove('header-color-background-5');
				headerOverlay.classList.add('color-background-1');
				if (pageAbout || pageLookbook) {
					breadCrumb.classList.remove('color-background-5');
				}
			}
		} else {
			if (colorScheme) {
				if (pageAbout || pageLookbook) {
					breadCrumb.classList.add('color-background-5');
				}
			}

			if (colorSchemeDark) {
				if (pageAbout || pageLookbook) {
					breadCrumb.classList.remove('color-background-5');
				}
			}
		}
	};

	banner_video();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			banner_video();
		});
	});

  } catch(e) { console.error(e); }
})();
})();
